export { default } from './UnscoredTableRoute'
